let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2gJf8")).then(() => parcelRequire('aXxee'));